import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { replace } from 'react-router-redux';
import {
  Card,
  Dimmer,
  Grid,
  Label,
  Loader,
  Segment,
  Table,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import PageNav from './PageNav';
import SearchFilter from './SearchFilter';
import { SelectListMultiple } from './Filters';
import LoadImage from './LoadImage';
import PictureItem from './PictureItem';
import PICTURE_TYPES from '../constants/pictureTypes';
import { flashErrorMessage } from '../actions/flash';
import { fetchM } from '../actions/fetchM';
import isNumber from '../utils/numbers/isNumber';
import { decodeSearch, encodeSearch } from '../utils/url';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

class PictureList extends Component {
  static propTypes = {
    notFoundNode: PropTypes.func,
    onClick: PropTypes.func,
    onCheck: PropTypes.func,
    onViewLarge: PropTypes.func,
    onRemove: PropTypes.func,
    onChange: PropTypes.func,
    headerNode: PropTypes.func,
    footerNode: PropTypes.func,
    buttonNode: PropTypes.func,
    projectID: PropTypes.string,
    unitLayoutID: PropTypes.string,
    where: PropTypes.shape({}),
    toggleable: PropTypes.bool,
    view: PropTypes.oneOf(['list', 'card']),
    searchRightNav: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    let advanceFilter = false;
    const isMobile = window.innerWidth < 768;
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const types = query.types || [];
    if (
        (types && types.length > 0)
      ) {
      advanceFilter = true;
    }
    return {
      advanceFilter,
      isMobile,
      currentPage,
      search,
      types,
    };
  }
  constructor(props) {
    super(props);
    const state = PictureList.getPropsToState(props);
    const view = props.view || 'list';
    this.state = {
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      view,
      ...state,
    };
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    this.replaceQuery(query);
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = PictureList.getPropsToState(nextProps);
    if (nextProps.view) {
      if (this.state.view !== nextProps.view) {
        state.view = nextProps.view;
      }
    }
    this.setState(state);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setPictures(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
        if (this.props.onChange) {
          this.props.onChange(this.state.data);
        }
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchPictures(q = {}) {
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign(q, this.props.where || {});
    const projectURL = this.props.projectID ? `/projects/${this.props.projectID}` : '';
    const layoutURL = this.props.unitLayoutID ? `/unit_layouts/${this.props.unitLayoutID}` : '';
    const url = projectURL.concat(layoutURL, `/pictures/?${qs.stringify(query)}`);
    let res;
    try {
      res = await store.dispatch(fetchM(url, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const data = await res.json();
      await this.setPictures(data);
      if (this.state.data.length < 1 && query.page > 1) {
        const que = decodeSearch(this.props.location.search);
        que.page = 1;
        this.replaceQuery(que);
      } else {
        // handle token.. etc
        await this.setComponentState({
          count,
          limit,
          offset,
        });
      }
    }
    await this.setLoading(false);
  }
  handleResize = () => {
    const isMobile = window.innerWidth < 768;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    this.fetchPictures(queryNew);
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  handleRefetch() {
    const query = decodeSearch(this.props.location.search);
    this.replaceQuery(query);
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  handleOnClick = (e, picture) => {
    if (this.props.onClick) {
      this.props.onClick(e, picture);
    }
  }
  handleToggleView = (e) => {
    e.preventDefault();
    const view = this.state.view === 'list' ? 'card' : 'list';
    this.setState({ view });
  }
  handleOnCheck = (picture) => {
    if (this.props.onCheck) {
      return this.props.onCheck({ picture });
    }
    return false;
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    this.setState({
      search: '',
    }, () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  handleSetAdvanceFilter = (advanceFilter) => {
    this.setState({
      advanceFilter,
    });
  }
  handleViewLarge = (e, picture) => {
    if (this.props.onViewLarge) {
      this.props.onViewLarge(e, picture);
    }
  }
  handleOnRemove = (e, picture) => {
    if (this.props.onRemove) {
      this.props.onRemove(e, picture);
    }
  }
  handleOnTagClick = (tag) => {
    const query = decodeSearch(this.props.location.search);
    query.search = tag;
    this.replaceQuery(query, true);
  }
  renderType(picture) {
    const { t } = this.props;
    let pictureType = picture.type;
    if (this.props.unitLayoutID && picture.unitLayouts && picture.unitLayouts.length > 0) {
      pictureType = picture.unitLayouts.find(ul =>
        ul.projectUnitLayoutID === this.props.unitLayoutID).type;
    } else if (this.props.projectID && picture.projects && picture.projects.length > 0) {
      pictureType = picture.projects.find(p => p.projectID === this.props.projectID).type;
    }
    const typeOption = PICTURE_TYPES.find(pt => pt.value === pictureType);
    return typeOption ? t(typeOption.text, { ns: TRANSLATION_FILES.screens }) : pictureType.replace('_', ' ');
  }
  renderLabel = (picture) => {
    if (picture.label && picture.label.trim().length > 0) {
      return picture.label;
    }
    if (this.state.isMobile) {
      return <span className="grey-text">No label set</span>;
    }
    return '-';
  }
  renderTags = (picture) => {
    if (picture.tags && picture.tags.length > 0) {
      return (
        <Label.Group size="tiny">
          {
            picture.tags.map((t, idx) => (
              <Label key={idx} as="a" onClick={() => this.handleOnTagClick(t)}>{t}</Label>
            ))
          }
        </Label.Group>
      );
    }
    if (!this.state.isMobile) {
      return '-';
    }
    return null;
  }
  renderBody() {
    const { t } = this.props;
    if (this.state.view === 'list') {
      return (
        this.state.data.length > 0 ?
        this.state.data.map((picture, key) => (
          <Table.Row
            key={key}
            disabled={this.handleOnCheck(picture)}
            onClick={e => this.handleOnClick(e, picture)}
          >
            {
              !this.state.isMobile &&
              <Table.Cell width={3}>
                <LoadImage
                  as="a"
                  centered
                  size="tiny"
                  picture={picture}
                  pictureSize={10}
                  onClick={e => this.handleViewLarge(e, picture)}
                />
              </Table.Cell>
            }
            {
              !this.state.isMobile &&
              <Table.Cell width={3}>
                {this.renderLabel(picture)}
              </Table.Cell>
            }
            <Table.Cell
              width={this.state.isMobile ? 16 : 3}
              className={this.state.isMobile ? null : 'capitalize'}
            >
              {
                this.state.isMobile ? (
                  <Grid columns="equal">
                    <Grid.Column width={16}>
                      <Label
                        className="capitalize"
                        attached="top left"
                        content={this.renderType(picture)}
                      />
                    </Grid.Column>
                    <Grid.Column width={6}>
                      <LoadImage
                        as="a"
                        centered
                        size="tiny"
                        picture={picture}
                        pictureSize={10}
                        onClick={e => this.handleViewLarge(e, picture)}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Grid columns="equal">
                        <Grid.Row>
                          <Grid.Column width={16}>
                            {this.renderLabel(picture)}
                          </Grid.Column>
                          <Grid.Column width={16}>
                            {this.renderTags(picture)}
                          </Grid.Column>
                        </Grid.Row>
                        {
                          this.props.buttonNode ? (
                            <Grid.Row>
                              <Grid.Column width={16} textAlign="right">
                                {
                                  this.props.buttonNode({
                                    loading: this.state.loading,
                                    picture,
                                    view: this.state.view,
                                    isMobile: this.state.isMobile,
                                  })
                                }
                              </Grid.Column>
                            </Grid.Row>
                          ) : null
                        }
                      </Grid>
                    </Grid.Column>
                  </Grid>
                ) : this.renderType(picture)
              }
            </Table.Cell>
            {
              !this.state.isMobile &&
              <Table.Cell>
                {this.renderTags(picture)}
                {
                  this.props.buttonNode ? (
                    <div className="picture-list-buttons">
                      {
                        this.props.buttonNode({
                          loading: this.state.loading,
                          picture,
                          view: this.state.view,
                          isMobile: this.state.isMobile,
                        })
                      }
                    </div>
                  ) : null
                }
              </Table.Cell>
            }
          </Table.Row>
        )) : (
          <Table.Row>
            <Table.Cell colSpan={this.state.isMobile ? null : 4} textAlign="center">
              {
                this.state.loading ? <Loader active inline="centered">Loading</Loader>
                : (this.props.notFoundNode || <p>{t('No pictures found')}.</p>)
              }
            </Table.Cell>
          </Table.Row>
        )
      );
    }
    return (
      <Table.Row>
        <Table.Cell>
          <Card.Group itemsPerRow={this.state.data.length > 0 ? 4 : 1} doubling stackable>
            {
              this.state.data.length > 0 ?
              this.state.data.map((picture, key) => (
                <PictureItem
                  key={key}
                  picture={picture}
                  pictureSize={30}
                  onViewLarge={e => this.handleViewLarge(e, picture)}
                  onRemove={e => this.handleOnRemove(e, picture)}
                  onTagClick={this.handleOnTagClick}
                  buttonNode={this.props.buttonNode ?
                    this.props.buttonNode({
                      loading: this.state.loading,
                      picture,
                      view: this.state.view,
                      isMobile: this.state.isMobile,
                    }) : null
                  }
                  labelNode={
                    <Label
                      className="capitalize"
                      attached="top left"
                      content={this.renderType(picture)}
                    />
                  }
                />
              )) : (
                <Card>
                  <Segment textAlign="center" vertical>
                    {
                      this.state.loading ? <Loader active inline="centered">{t('Loading')}</Loader>
                      : (this.props.notFoundNode || <p>{t('No pictures found')}.</p>)
                    }
                  </Segment>
                </Card>
              )
            }
          </Card.Group>
        </Table.Cell>
      </Table.Row>
    );
  }
  render() {
    const {
      count, limit, offset, data, loading, currentPage, view,
    } = this.state;
    const { t } = this.props;
    return (
      <div>
        <Dimmer
          inverted style={{ zIndex: 20 }}
          active={this.state.loading && this.state.data.length > 0}
        >
          <Loader inline="centered">{t('Loading')}</Loader>
        </Dimmer>
        <Table
          fixed={view === 'card'}
          striped unstackable
        >
          <Table.Header fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan={this.state.isMobile ? null : 4}>
                <Grid columns={1} verticalAlign="middle">
                  {
                    this.props.toggleable &&
                    <Grid.Column>
                      <Label
                        as="button"
                        attached="top left"
                        size="small"
                        icon={`${view === 'list' ? 'block' : 'list'} layout`}
                        content={t(view === 'list' ? 'Card' : 'List')}
                        onClick={this.handleToggleView}
                        disabled={this.state.loading}
                      />
                    </Grid.Column>
                  }
                  <Grid.Column>
                    {
                      this.props.headerNode ?
                      this.props.headerNode({
                        count,
                        limit,
                        offset,
                        dataSize: data.length,
                        loading,
                        currentPage,
                        onChange: this.handleChangePage,
                      }) : (
                        <SearchFilter
                          inTable
                          advanceFilter={this.state.advanceFilter}
                          isLoading={loading}
                          onChange={this.handleFilterOnChange}
                          onClose={this.handleClearFilter}
                          search={this.state.search}
                          setAdvanceFilter={this.handleSetAdvanceFilter}
                          leftNav={(
                            <PageNav
                              currentPage={currentPage}
                              count={count}
                              limit={limit}
                              offset={offset}
                              dataSize={data.length}
                              loading={loading}
                              onChange={this.handleChangePage}
                            />
                          )}
                          rightNav={this.props.searchRightNav}
                        >
                          <SelectListMultiple
                            filterName="types"
                            hasSearch
                            headerText={t('Select Types')}
                            onChange={this.handleFilterOnChange}
                            onClose={this.handleClearFilter}
                            options={PICTURE_TYPES.map(status => ({
                              ...status,
                              text: t(status.text, { ns: TRANSLATION_FILES.screens }),
                            }))}
                            placeholder={t('Select Types')}
                            value={this.state.types}
                          />
                        </SearchFilter>
                      )
                    }
                  </Grid.Column>
                </Grid>
              </Table.HeaderCell>
            </Table.Row>
            {
              view === 'list' &&
              !this.state.isMobile &&
              <Table.Row>
                <Table.HeaderCell>{t('Picture')}</Table.HeaderCell>
                <Table.HeaderCell>{t('Label')}</Table.HeaderCell>
                <Table.HeaderCell>{t('Type')}</Table.HeaderCell>
                <Table.HeaderCell>{t('Tags')}</Table.HeaderCell>
              </Table.Row>
            }
          </Table.Header>
          <Table.Body>
            {this.renderBody()}
          </Table.Body>
          <Table.Footer fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan={this.state.isMobile ? null : 4}>
                {
                  this.props.footerNode ?
                  this.props.footerNode({
                    count,
                    limit,
                    offset,
                    dataSize: data.length,
                    loading,
                    currentPage,
                    onChange: this.handleChangePage,
                  }) : (
                    <Grid columns="equal" verticalAlign="middle">
                      <Grid.Column>
                        <PageNav
                          upward
                          currentPage={currentPage}
                          count={count}
                          limit={limit}
                          offset={offset}
                          dataSize={data.length}
                          loading={loading}
                          onChange={this.handleChangePage}
                        />
                      </Grid.Column>
                    </Grid>
                  )
                }
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(
  withRouter(PictureList, { withRef: true }),
);



// WEBPACK FOOTER //
// ./src/components/PictureList.jsx